import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterPriceSearchValueObject extends ValueObject {
  #price

  constructor({price}) {
    super()
    this.#price = price
  }

  static create({price}) {
    return new FilterPriceSearchValueObject({price: FilterRangeSearchValueObject.create(price)})
  }

  static validate({from, to}) {
    const hasFrom = from !== null && from !== undefined
    const hasTo = to !== null && to !== undefined
    if (!hasFrom && !hasTo) {
      throw new InvalidParamsSharedError('At least one of from or to parameters must be provided')
    }
  }

  static createFromRange({config, from, to}) {
    FilterPriceSearchValueObject.validate({from, to})
    const {DEFAULT_PRICE_SEARCH} = config.get('searchFilters')
    return new FilterPriceSearchValueObject({
      price: FilterRangeSearchValueObject.create({
        from: from || DEFAULT_PRICE_SEARCH.from,
        to: to || DEFAULT_PRICE_SEARCH.to
      })
    })
  }

  static createWithDefaultValue({config, price}) {
    const {DEFAULT_PRICE_SEARCH} = config.get('searchFilters')

    return new FilterPriceSearchValueObject({
      price: FilterRangeSearchValueObject.create({
        from: price?.from || DEFAULT_PRICE_SEARCH.from,
        to: price?.to || DEFAULT_PRICE_SEARCH.to
      })
    })
  }

  static createFromUrl({config, price, url = ''}) {
    const {DEFAULT_PRICE_SEARCH} = config.get('searchFilters')
    const {SEMANTIC_KEYWORDS} = config.get('seo')

    if (url.includes(SEMANTIC_KEYWORDS.RENTING.CHEAP)) {
      return new FilterPriceSearchValueObject({
        price: FilterRangeSearchValueObject.create({
          from: null,
          to: 400
        })
      })
    }

    const urlQueryParms = new URLSearchParams(url.split('?')[1] || '')
    if (urlQueryParms.has('maxFee') || urlQueryParms.has('minFee')) {
      return new FilterPriceSearchValueObject({
        price: FilterRangeSearchValueObject.create({
          from: urlQueryParms.get('minFee') || DEFAULT_PRICE_SEARCH.from,
          to: urlQueryParms.get('maxFee') || DEFAULT_PRICE_SEARCH.to
        })
      })
    }

    return new FilterPriceSearchValueObject({
      price: FilterRangeSearchValueObject.create({
        from: price?.from || DEFAULT_PRICE_SEARCH.from,
        to: price?.to || DEFAULT_PRICE_SEARCH.to
      })
    })
  }

  static createQueryParams({config, listingSectionId, price}) {
    const {DEFAULT_PRICE_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')
    if (listingSectionId === '6') {
      return new FilterPriceSearchValueObject({
        price: {
          from: QueryParamSharedValueObject.createForSingle({
            key: FILTER_QUERY_PARAMS[FILTER_NAMES.FEE].from,
            value: price?.from || DEFAULT_PRICE_SEARCH.from
          }),
          to: QueryParamSharedValueObject.createForSingle({
            key: FILTER_QUERY_PARAMS[FILTER_NAMES.FEE].to,
            value: price?.to || DEFAULT_PRICE_SEARCH.to
          })
        }
      })
    }

    return new FilterPriceSearchValueObject({
      price: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.PRICE].from,
          value: price?.from || DEFAULT_PRICE_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.PRICE].to,
          value: price?.to || DEFAULT_PRICE_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#price.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#price.from.isEmpty && {...this.#price.from.queryParam}),
      ...(!this.#price.to.isEmpty && {...this.#price.to.queryParam})
    }
  }

  get value() {
    return this.#price.value
  }

  toJSON() {
    return {
      price: this.#price.toJSON()
    }
  }
}
